<script setup lang="ts">

import { GetTheAppButton } from "@components/GetTheAppButton";

import Headline from "./Components/Headline.vue";
import HeroTestimonial from "./Components/HeroTestimonial.vue";
import Marketplace from "./Components/Marketplace.vue";
import VehicleMaintenance from "./Components/VehicleMaintenance.vue";
import HealthMonitor from "./Components/HealthMonitor.vue";
import CarbucksProtect from "./Components/CarbucksProtect.vue";

</script>

<template>

    <div>
        <Headline />
        <HeroTestimonial />
        <VehicleMaintenance />

        <!-- <CarbucksProtect />
        <HealthMonitor /> -->

        <Marketplace />

        <div class="max-w-5xl mx-auto px-4 mt-16 mb-16">
            <div class="rounded-[3rem] p-16 bg-[#3e3c94] text-white text-center">
                <h1 class="text-3xl font-semibold mb-4">
                    Want to see how it can benefit 
                    <br class="hidden md:block"/>
                    your driving experience?
                </h1>
                <GetTheAppButton />
            </div>
        </div>
            
    </div>

</template>